var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M1.2654 0C0.929799 0 0.607938 0.133275 0.370629 0.370506C0.133319 0.607737 0 0.929492 0 1.26499V21.7274C0 22.0629 0.133319 22.3847 0.370629 22.6219C0.607938 22.8591 0.929799 22.9924 1.2654 22.9924H12.2846V14.0945H9.28554V10.6208H12.2846V8.0605C12.2846 5.09031 14.0991 3.47365 16.7514 3.47365C17.6458 3.47044 18.5396 3.51605 19.429 3.61027V6.71455H17.5917C16.1491 6.71455 15.8707 7.40018 15.8707 8.40458V10.6208H19.3101L18.8596 14.0945H15.8707V23H21.7346C22.0702 23 22.3921 22.8667 22.6294 22.6295C22.8667 22.3923 23 22.0705 23 21.735V1.26752C23 0.932022 22.8667 0.610267 22.6294 0.373036C22.3921 0.135805 22.0702 0.00253003 21.7346 0.00253003H1.2654V0Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.585a2993.svg";
export { ForwardRef as ReactComponent };